var map = {
	"./en.json": [
		3392,
		7
	],
	"./es-CO.json": [
		3393,
		8
	],
	"./fr.json": [
		3394,
		9
	],
	"./ko.json": [
		3395,
		10
	],
	"./pt-BR.json": [
		3396,
		11
	],
	"./th.json": [
		3397,
		12
	],
	"./vi.json": [
		3398,
		13
	],
	"./zh-CN.json": [
		3399,
		14
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2104;
module.exports = webpackAsyncContext;